import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import { compose } from 'redux';
import ThankYouImage from '../../images/thank_you.png';
import { navigationMapping } from '../../consts/navigation';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const PromotionFormModal = ({ promotionCreated, closeModal, channelName, history, t, }) => {
  const classes = useStyles({ promotionCreated, });
  const handlebutonClick = () => {
    closeModal();
    history.push({
      pathname: navigationMapping.ads.table_url,
    });
  };

  return (
    <div className={classes.container}>
      <div className={classes.imgContainer}>
        <img alt="thank_you_image" src={ThankYouImage} />
      </div>
      <br />
      {promotionCreated ? (
        <h4> {t('created')} {channelName} </h4>
      ) : (
        <h4> {t('fail')} </h4>
      )}
      <div className={classes.imgContainer}>
        <button type="submit" className="submit-button" onClick={handlebutonClick}>{t('got_it')}</button>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  container: (props) => ({
    minWidth: '400px',
    '& h4': {
      textAlign: 'center',
      color: props.promotionCreated ? 'inherit' : 'red',
    },
  }),
  imgContainer: {
    marginTop: '2em',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

PromotionFormModal.propTypes = {
  promotionCreated: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  channelName: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    promotionCreated: state.promotions.promotionCreated,
    channelName: state.promotions?.data?.channel_name,
  };
};

export default compose(
  withRouter,
  withScopedTranslations('ads.promotion_modal'),
  connect(mapStateToProps)
)(PromotionFormModal);
